import { createValidationDataObject } from "@/utils/form-validation";
import { EMAIL_REGEX } from "../index";

export const webPaymentSetupAccountValidator = {
  name: (str) => {
    if (!str) {
      return createValidationDataObject(false, "Name is required");
    }

    return createValidationDataObject();
  },
  email: (str) => {
    if (!EMAIL_REGEX.test(str)) {
      return createValidationDataObject(
        false,
        "A valid email address is required"
      );
    }

    return createValidationDataObject();
  },
};
